export const KRH_AROUND = 'krh-around';
export const KRH_VERTICAL_SIDES = 'krh-vertical-sides';
export const KRH_VERTICAL = 'krh-vertical';
export const TSH = 'tsh';
export const RRH_AROUND = 'rrh-around';
export const KRH_VERTICAL_RRH_HORIZONTAL = 'krh-vertical-rrh-horizontal';

export default [
  KRH_AROUND,
  KRH_VERTICAL_SIDES,
  KRH_VERTICAL,
  TSH,
  RRH_AROUND,
  KRH_VERTICAL_RRH_HORIZONTAL,
];
